import { TextStyle } from "react-native"
import { presets as textPresets, presetsColors } from "../text/text.presets"

/**
 * All text will start off looking like this.
 */
const BASE: TextStyle = {
  ...textPresets().body2,
  color: undefined,
  height: "40px",
  lineHeight: 17,
  paddingVertical: 8
}

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const presets = (colorScheme = "light") => ({
  /**
   * The default text styles.
   */
  default: { ...BASE, ...presetsColors(colorScheme) },
})

export const presetsLight = presets()

/**
 * A list of preset names.
 */
export type InputPresets = keyof typeof presetsLight
